import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';

import { appendMode, REQUEST_SIZE } from 'constants/general';
import { KCL_DOCUMENT_CHECK_ADMINS, KCL_DOCUMENT_CHECK_MARPO } from 'features/common/acl/constants';
import fetch from 'features/common/fetch';
import { DOCUMENTS_TO_REVIEW_FORM_NAME } from 'features/views/productionControl/documentsToReview/form';
import { SELECTION_CRITERIA_FORM_NAME } from 'features/views/productionControl/selectionCriteria/form';
import { getUserOid } from 'features/views/user/selectors';
import { cleanse, generateCommonFetchActions } from 'utils';

import { appendDocumentsToReview, setClientsDocumentsToReview, setDocumentsToReview } from '../slice';

export const fetchDocumentsToReview =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const documentsToReviewFormData = await getFormData(DOCUMENTS_TO_REVIEW_FORM_NAME);
		const selectionCriteriaFormData = await getFormData(SELECTION_CRITERIA_FORM_NAME);

		const queryParams = cleanse({
			waveId: selectionCriteriaFormData?.wave,
			policyNo: documentsToReviewFormData?.policyNumber,
			documentState: documentsToReviewFormData?.controlStatus,
			noticeFinalState: documentsToReviewFormData?.centralConsent,
			documentType: documentsToReviewFormData?.documentType,
			policyHolder: documentsToReviewFormData?.client,
			regionId: selectionCriteriaFormData?.region,
			superiorOid: selectionCriteriaFormData?.superior,
			solverOid: selectionCriteriaFormData?.subordinate,
			size: REQUEST_SIZE,
			page: 0,
		});
		dispatch(fetchData({ queryParams }));
	};

export const fetchData =
	({ queryParams }, append = appendMode.SET) =>
	(dispatch) => {
		dispatch(
			fetch.actions.get(fetch.constants.urls.koprDocumentsToReview, {
				queryParams,
				onSuccess: [
					(response) => () => {
						if (!response || !response.body) return;
						const data = response?.body?.data;
						dispatch(
							append === appendMode.APPEND ? appendDocumentsToReview(data) : setDocumentsToReview(data),
						);
					},
				],
			}),
		);
	};

export const { loadSorted, loadMore, loadPage, reload } = generateCommonFetchActions(
	fetchData,
	fetch.constants.urls.koprDocumentsToReview,
);

export const fetchClientsDocumentsToReview =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const selectionCriteriaFormData = await getFormData(SELECTION_CRITERIA_FORM_NAME);
		const userOid = getUserOid(getState());

		const userIsCentralOrMarpo = hasPermissionByIds(getState())([
			...KCL_DOCUMENT_CHECK_ADMINS,
			...KCL_DOCUMENT_CHECK_MARPO,
		]);

		dispatch(
			fetch.actions.get(fetch.constants.urls.koprClientsDocumentsToReview, {
				queryParams: cleanse({
					waveId: selectionCriteriaFormData?.wave,
					regionId: selectionCriteriaFormData?.region,
					superiorOid: userIsCentralOrMarpo ? selectionCriteriaFormData?.superior : userOid,
					solverOid: selectionCriteriaFormData?.subordinate,
				}),
				onSuccess: [
					(response) => () => {
						if (!response || !response.body) return;
						const data = response?.body;
						dispatch(setClientsDocumentsToReview(data?.values));
					},
				],
			}),
		);
	};
